module.exports = __webpack_public_path__ + "assets/img/m702-badge-2.1f0e9f13.png";